import React from 'react';
import _ from 'lodash';
import config from 'config';

const coachIcon =
  'https://res.cloudinary.com/dljcvcx8l/' +
  'image/upload/v1556128910/' +
  'Square_Logo_Black_wodins.jpg';

const trybePubKey = config.stripePubKey;
const env = 'PROD';
// const env = 'DEV';

let enable6monthCoupon = true;

class UserPayment extends React.Component {
  constructor(props) {
    super(props);

    const {
      coachOrgId,
      uid,
      email,
    } = this.prepURLData();

    this.state = {
      coachOrgId,
      uid,
      email,
      canBuy: false,
      isAwaitingPaidConf: null,
      hasUserPaid: false,
      subPrice: null,
      paymentErr: null,
      planSelected: {},
    };
  }

  componentDidMount(){
    this.getProductInfo();
    this.loadStripe(this.confgStripe);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.userPaymentStatus !== this.props.userPaymentStatus){
      if(nextProps.userPaymentStatus === 'success'){
        this.setState({
          hasUserPaid: true,
          isAwaitingPaidConf: false
        })
      } else if(nextProps.userPaymentStatus === 'err'){
        this.setState({
          hasUserPaid: true,
          isAwaitingPaidConf: false,
          paymentErr: nextProps.userPaymentMsg || null
        });
      }
    }
  }

  getCanBuy = () => {
    const { uid, email, coachOrgId } = this.state;
    const canBuy = coachOrgId && uid && email ? true : false;
    return canBuy;
  }

  prepURLData = () => {
    const coachOrgId = this.getURLVal('coachOrgId');
    const uid = this.getURLVal('uid');
    const email = this.getURLVal('email');

    return {
      coachOrgId,
      uid,
      email,
    }
  }

  getProductInfo(){
    const { coachOrgId } = this.state;
    const { paymentActions } = this.props.actions;
    paymentActions.fetchProductInfo(coachOrgId);
  }

  confgStripe = () => {
    this.stripehandler = window.StripeCheckout.configure({
      key: trybePubKey,
      image: coachIcon,
      locale: 'auto',
      zipCode: true,
      token: (stripeData) => {
        this.setState({ isAwaitingPaidConf: true });

        const { coachOrgId, uid, planSelected } = this.state;
        const { stripe_plan_id, price } = planSelected;
        const { paymentActions } = this.props.actions;
        const { productName, accessType, stripePubKey } = this.props;

        const paymentDetails = {
          stripePlanId: stripe_plan_id,
          coachOrgId,
          stripePubKey: stripePubKey,
          paymentType: 'subscription',
          amount: price,
          productName,
          accessType,
        }

        stripeData.paymentDetails = paymentDetails;
        paymentActions.initUserPayment(coachOrgId, uid, stripeData);
        paymentActions.listenUserPaymentSuccess(coachOrgId, uid, stripeData);
        paymentActions.listenUserPaymentErr(coachOrgId, uid, stripeData);
      }
    });
  }

  loadStripe(confStripCheckout) {
    if(!window.StripeCheckout) {
      const script = document.createElement('script');
      script.onload = function(){
        confStripCheckout();
      };
      script.src = 'https://checkout.stripe.com/checkout.js';
      document.head.appendChild(script);
    } else {
      confStripCheckout();
    }
  }

  getStripeDescr = (planSelected) => {
    const time_unit = planSelected.time_unit;
    const time_val = planSelected.time_val;
    const customDescr = planSelected.custom_descr;

    if(customDescr){
      return customDescr;
    } else if(time_val === 1){
      const capFirst = time_unit.charAt(0).toUpperCase() + time_unit.slice(1);
      return `${capFirst}ly Membership`
    } else {
      return `Every ${time_val} ${time_unit}s`
    }
  }

  maybeShowCouponPrice = (plan) => {
    const planUpdated = Object.assign({}, plan);
    const now = new Date().getTime();
    const endOfMay = 1559372399000; // 5/31/19 11:59pm PST

    if(now <= endOfMay){
      if(plan.price === 1500){
        planUpdated.promoText = '$5 off first payment until 5/31';
        planUpdated.custom_descr = '$5 discount will be applied on 1st payment';
      } else if(plan.price === 7500 && enable6monthCoupon){
        planUpdated.promoText = '$10 off first payment until 5/31';
        planUpdated.custom_descr = '$10 discount will be applied on 1st payment';
      }
    }

    return { plan: planUpdated };
  }

  openStripe(e:Object, planSelected) {
    const canBuy = this.getCanBuy();

    if(!canBuy){
      alert('Sorry, there was an error. Please refresh the page.')
      return;
    }

    const { plan } = this.maybeShowCouponPrice(planSelected.toJS());

    this.setState({ planSelected: plan })

    const { productName } = this.props;

    this.stripehandler.open({
      name: productName,
      description: this.getStripeDescr(plan),
      amount: plan.price,
      allowRememberMe: true,
      image: coachIcon,
      panelLabel: 'Subscribe',
      zipCode: true,
      email: this.state.email || null,
    });
  }

  getURLVal(key){
    let result = null;
    const query = window.location.search.substring(1);
    const strings = query.split('&');
    _.each(strings, (string) => {
      const pair = string.split('=');
      let currKey = pair[0];
      if(currKey == key){
        let currVal = pair[1];
        currVal = currVal.replace('+',' ');
        result = currVal;
      }
    });

    return result;
  }

  getButtonCTA = (plan) => {
    const ctaStart = `Join for $`;
    const ctaMid = plan.price/100;
    const time_unit = plan.time_unit;
    const time_val = plan.time_val;

    let ctaEnd;
    if(plan.time_val === 1){
      let timeUnitShort;
      if(time_unit === 'month'){
        timeUnitShort = 'mo'
      } else if(time_unit === 'year'){
        timeUnitShort = 'yr'
      }

      ctaEnd = '/' + timeUnitShort || time_unit;
    } else {
      ctaEnd = ` every ${time_val} ${time_unit}s`;
    }

    return ctaStart + ctaMid + ctaEnd;
  }

  renderButtons = () => {
    if(!this.props.plans) return null;

    const buttons = this.props.plans.map((plan, idx) => {
      const {
        plan: updatedPlan
      } = this.maybeShowCouponPrice(plan.toJS());

      const promoText = updatedPlan.promoText;
      const cta = this.getButtonCTA(updatedPlan);

      return (
        <div
          className='button-container'
          key={idx}>
          <button
            className='custom-button'
            onClick={ (e) => this.openStripe.bind(this)(e, plan) }>
            { cta }
          </button>
          { promoText ?
            <div className='promotion-text'>*{promoText}</div>
            : null
          }
        </div>
      )
    })

    return (
      <div className='buttons-container'>
        { buttons }
      </div>
    )
  }

  renderPurchaseScene(){
    const { isAwaitingPaidConf } = this.state;
    const showPayButton = isAwaitingPaidConf ? false : true;

    return (
      <div className='flex-column'>
        { showPayButton ?
          <div className='flex-column'>
            <div className='title-text'>Upgrade Membership</div>
            <img
              src='https://res.cloudinary.com/dljcvcx8l/image/upload/v1556128910/Square_Logo_White_npgk7o.png'
              className='coach-logo' />
            <div className='flex-column align-start'>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Access to all workouts</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Access to all programs</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Private community with Tom</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Exercise progressions</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Form cues</div>
              </div>
            </div>
            { this.renderButtons.bind(this)() }
          </div>
          :
          <div className='loading-container'>
            <div className='loading-text'>Processing payment and granting access...</div>
            <div className='loading-text'>This may take up to 10 seconds.</div>
            <div className='loader'></div>
            <div className='loading-text'>{'Until directed to the confirmation page,\nno charge will be made.'}</div>
          </div>
        }
      </div>
    )
  }

  renderConfirmation(){
    if(this.state.paymentErr){
      return (
        <div className='conf-container'>
          <img
            src={require('../../images/error.png')}
            className='error-img'
          />

          <div className='conf-text'>
            Uh oh, we ran into this error when processing the payment.
          </div>

          <div className='conf-text conf-text-err'>
            { this.state.paymentErr }
          </div>

          <div className='conf-text'>
            Please email support@trybe.do so we can help you finish upgrading your membership.
          </div>
        </div>
      )
    } else {
      return (
        <div className='conf-container'>
          <div className='conf-text'>
            Membership Successfully Upgraded
          </div>
          <img
            src={require('../../images/confirmationCheckmark.png')}
            className='conf-checkmark' />
        </div>
      )
    }
  }

  render() {
    const { hasUserPaid } = this.state;
    return (
      <div className='flex-column user-payment-container'>
        { hasUserPaid ?
          this.renderConfirmation()
          :
          this.renderPurchaseScene()
        }
      </div>
    );
  }
}

module.exports = UserPayment;


// WEBPACK FOOTER //
// ./src/components/payments/UserPayment.js